import { useForm as createUseForm } from "@ant-design-vue/use";
import { Col, Modal, Row } from "ant-design-vue";
import lodash from "lodash";
import moment from "moment";
import { defineAsyncComponent, reactive, toRaw, watch } from "vue";
import { addModal, setIsLoading as setIsLoadingApp } from "../../../../app.logic";
import { openModalForm as openModalFormRemark } from "../../../../components/form/remark-form.logic";
import { setAppPageHeader } from "../../../../components/layout/app-layout/app-layout.logic";
import i18n from "../../../../i18n";
import router from "../../../../router";
import store from "../../../../store";
import {
    createButton,
    createButtonActive,
    createButtonArchive,
    createButtonCancel,
    createButtonCopy,
    createButtonCreate,
    createButtonDelete,
    createButtonEdit,
    createButtonSave,
    createButtonView
} from "../../../../utils/button";
import { modalStyleIFrame } from "../../../../utils/constant";
import {
    checkAttribute,
    copyForm,
    initUseForm,
    onClickActive,
    onClickActiveAll,
    onClickArchive,
    onClickArchiveAll,
    onClickCreate,
    onClickDelete,
    onClickDeleteAll,
    onClickEdit,
    onClickView
} from "../../../../utils/form";
import { createLoading } from "../../../../utils/loading";
import { has, have } from "../../../../utils/menu-context";
import {
    createAppPageHeaderTop,
    createManageActive,
    createManageArchive,
    createManageDelete,
    createManageExportCsv,
    createManageExtraCreate,
    createManageSelect,
    createPage,
    createRowActionEdit,
    createRowActionView
} from "../../../../utils/page";
import { flatWhereGroup } from "../../../../utils/search";
import { addRules, required, requiredWhen, validateError } from "../../../../utils/validate";
import { createRulesCompanyAttachment } from "../company/company.section";
import { createRules as createRulesCompany } from "../company/company.logic";
import { callInspectionTypeByKey, createForm as createFormCompanyInspection } from "./company-inspection.logic";
import { createConditionAction, createConditionForm } from "./company-request.condition";
import {
    callCompanyRequestStatus,
    callCompanyRequestStatusForReceive,
    callUserCompanyByNameTh,
    createColumns,
    createField,
    createRulesCompanyCountry,
    createRulesCompanyInspection,
    createRulesCompanyProduct,
    createRulesCompanyUser
} from "./company-request.section";

const CIFrame = defineAsyncComponent(() => import("../../../../components/iframe/CIFrame"));
const CIcon = defineAsyncComponent(() => import("../../../../components/icon/CIcon"));

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/companyRequest";
export const routerPrefix = "company-requests";

export const callSave = ({ form }) => store.dispatch(`${actionPrefix}/save`, { data: form });
export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callActive = ({ id }) => store.dispatch(`${actionPrefix}/active`, { id });
export const callArchive = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id });
export const callDelete = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id, config: { params: { isHardDelete: true } } });
export const callActiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/activeAll`, { ids });
export const callArchiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids });
export const callDeleteAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids, config: { params: { isHardDelete: true } } });
export const callChanges = ({ id, criteria }) => store.dispatch(`${actionPrefix}/changes`, { id, criteria });
export const callReportChangeAddress = ({ data }) => store.dispatch(`${actionPrefix}/reportChangeAddress`, { data });

export const onSearch = ({ props, page, isSet = true }) => {
    const where = page.where || [];
    setIsLoading(true);
    window.onSearch?.({ props, page });
    return callSearch({ criteria: { ...page, data: [], where: [...where, ...createWhereRole({ props })] } })
        .then(page => (isSet ? (state.page = { ...page, where }) : page))
        .finally(() => setIsLoading(false));
};

export const onClickSave = ({ props, data, refs, refStatus }) => {
    const { viewOnly } = props;
    return data.useForm
        .validate()
        .then(() => {
            data.useForm.modelRef.refCompanyTmp.isSave = true;
            setIsLoadingApp(true);
            return callSave({ form: refStatus ? { ...data.useForm.modelRef, refStatus } : data.useForm.modelRef })
                .finally(() => setIsLoadingApp(false))
                .then(record => {
                    if (viewOnly) initForm({ props, data, refs });
                    else onClickView({ record, routerPrefix });
                });
        })
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const onClickReport = ({ callReport, fileName, type = "application/pdf" }) => {
    setIsLoadingApp(true);
    return callReport()
        .then(byte => {
            const { saveAs } = require("file-saver");
            const blob = new Blob([byte], { type });
            saveAs(blob, fileName);
        })
        .finally(() => setIsLoadingApp(false));
};

export const createSearchOneCriteria = ({ props, id, forLog }) => {
    if (!forLog) {
        return {
            select: [
                "**",
                "refCompany.refFactoryAddrTh.**",
                "refCompany.refFactoryAddrEn.**",
                "refCompany.refOfficeAddrTh.**",
                "refCompany.refOfficeAddrEn.**",
                "refCompanyTmp.refFactoryAddrTh.**",
                "refCompanyTmp.refFactoryAddrEn.**",
                "refCompanyTmp.refOfficeAddrTh.**",
                "refCompanyTmp.refOfficeAddrEn.**",
                "refCreateBy.fullName"
            ],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }, ...createWhereRole({ props })],
            children: [
                { name: "attachments", select: ["*"], page: 0, size: 1000000, sort: [] },
                {
                    name: "refCompanyTmp.companyAttachments",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "refCompanyAttachmentType.seq", type: "ASC" }],
                    children: [{ name: "attachments", select: ["**"], page: 0, size: 1000000, sort: [{ name: "createDate", type: "ASC" }] }]
                },
                { name: "refCompanyTmp.companyProducts", select: ["**"], page: 0, size: 1000000, where: [{ name: "isActive", type: "Boolean", operator: "=", value: true }], sort: [{ name: "refProduct.code", type: "ASC" }] },
                {
                    name: "refCompanyTmp.companyCountries",
                    select: ["**", "refCountry.**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "refCountry.seq", type: "ASC" }]
                },
                {
                    name: "refCompanyTmp.companyInspections",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "inspectionEndDatetime", type: "DESC" }]
                },
                {
                    name: "refCompanyTmp.samplingRequests",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "requestDate", type: "DESC" }],
                    children: [
                        {
                            name: "samplingProducts",
                            select: ["**", "refCompanyProduct.**"],
                            page: 0,
                            size: 1000000,
                            sort: [{ name: "createDate", type: "ASC" }]
                        }
                    ]
                },
                {
                    name: "refCompanyTmp.certificateRequests",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "requestDate", type: "DESC" }],
                    children: [
                        {
                            name: "certificateProducts",
                            select: [
                                "**",
                                "refCompanyProduct.**",
                                "refSamplingProduct.refCompanyProduct.**",
                                "refCertificateRequest.refExportCountry.*"
                            ],
                            page: 0,
                            size: 1000000,
                            sort: [{ name: "createDate", type: "ASC" }]
                        }
                    ]
                },
                { name: "refCompany.companyProducts", select: ["**"], page: 0, size: 1000000, where: [{ name: "isActive", type: "Boolean", operator: "=", value: true }], sort: [] },
                { name: "refCompany.companyCountries", select: ["**", "refCountry.**"], page: 0, size: 1000000, sort: [] },
                { name: "refCompany.userCompanies", select: ["id"], page: 0, size: 1, sort: [{ name: "createDate", type: "ASC" }] }
            ]
        };
    } else {
        return {
            select: [],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }],
            children: []
        };
    }
};

export const createFormTitle = ({ data }) => {
    const { modelRef, initialModel } = data.useForm;
    return modelRef.id
        ? `${modelRef.refCompanyRequestType.value}${modelRef.requestNo ? ` ${modelRef.requestNo} ` : " "}(${initialModel.refStatus?.value})`
        : i18n.global.t("button.create");
};

export const createWhereRole = ({ props }) => {
    const { menuContext } = props;
    const whereGroup = [];
    const userInfo = store.state.resource.auth.info?.user;
    if (has({ menuContext, key: "forCompany" })) {
        whereGroup.push([{ name: "refCompany.userCompanies.refUser.username", type: "String", operator: "=", value: userInfo.username }]);
    }
    if (has({ menuContext, key: "forCompanyReceive" })) {
        whereGroup.push([
            { name: "refStatus.key", type: "String", operator: "!in", value: ["Draft"] },
            { logic: "OR", name: "createBy", type: "String", operator: "=", value: userInfo.username }
        ]);
    }
    if (has({ menuContext, key: "forCompanyReview" })) {
        whereGroup.push([
            { name: "refStatus.key", type: "String", operator: "!in", value: ["Draft", "Wait", "Re Edit", "Not Receive"] },
            { logic: "OR", name: "createBy", type: "String", operator: "=", value: userInfo.username }
        ]);
    }
    if (has({ menuContext, key: "forCompanyApprove" })) {
        whereGroup.push([
            { name: "refStatus.key", type: "String", operator: "in", value: ["Wait Approve", "Approve", "Reject"] },
            { logic: "OR", name: "createBy", type: "String", operator: "=", value: userInfo.username }
        ]);
    }
    return flatWhereGroup({ where: whereGroup, logic: "OR" });
};

export const createForm = () => {
    return {
        refCompany: null,
        requestNo: null,
        requestDatetime: null,
        refCompanyTmp: null,
        refCompanyRequestType: null,
        refStatus: null,
        receiveDatetime: null,
        refReceiver: null,
        reviewDatetime: null,
        refReviewer: null,
        startDatetime: null,
        endDatetime: null,
        refInspector: null,
        approveDatetime: null,
        refApprover: null,
        remark: null,
        isOfficerRequest: null,
        attachments: []
    };
};

export const createRules = () => {
    return {
        refCompany: [required],
        refCompanyRequestType: [required],
        refCompanyTmp: [required]
    };
};

export const loadForm = ({ props, data, refs }) => {
    setIsLoading(true);
    const { form } = props;
    const { id, useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else if (id) {
        promise = callSearch({ criteria: createSearchOneCriteria({ props, data, refs, id }) });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise
        .then(page => initUseForm({ props, data, refs, page, routerPrefix }))
        .then(() => loadDefaultForm({ props, data, refs }))
        .then(() => initByRole({ props, data, refs }))
        .then(() => initUseForm({ props, data, refs, page: { data: [modelRef] }, routerPrefix }))
        .finally(() => setIsLoading(false));
};

export const loadDefaultForm = ({ data }) => {
    const promises = [];
    promises.push(Promise.all([callCompanyRequestStatus({})]).then(arr => (data.statuses = arr[0])));
    return Promise.all(promises);
};

export const initState = ({ props }) => {
    const menuContext = props.menuContext;
    state.columns = createColumns({ props }).map(d => {
        return lodash.mergeWith(
            state.columns.find(d2 => d.dataIndex === d2.dataIndex),
            d,
            (objValue, srcValue, key) => {
                if (["searchValue"].includes(key)) return objValue;
            }
        );
    });
    state.manages = [
        createManageSelect({ menuContext }),
        createManageActive({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickActiveAll({ rowSelection, callActiveAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading })
        }),
        createManageArchive({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickArchiveAll({ rowSelection, callArchiveAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading })
        }),
        createManageDelete({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickDeleteAll({ rowSelection, callDeleteAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading }),
            getCheckboxProps: ({ record }) => ({ disabled: !["Draft"].includes(record?.refStatus?.key) })
        }),
        createManageExportCsv({ menuContext, callData: ({ page }) => onSearch({ props, page: { ...lodash.cloneDeep({ ...page, page: 0, size: 1000000 }) }, isSet: false }) })
    ];
    state.manageExtras = [createManageExtraCreate({ menuContext, onClick: () => onClickCreate({ routerPrefix }) })];
    state.rowActions = [
        createRowActionView({ menuContext, onClick: ({ record }) => onClickView({ record, routerPrefix }) }),
        createRowActionEdit({
            menuContext,
            onClick: ({ record }) => onClickEdit({ record, routerPrefix }),
            visible: ({ record }) => state.conditionAction.canEdit({ props, record })
        })
    ];
};

export const initForm = ({ props, data, refs }) => {
    checkAttribute({ props, data, refs });
    data.form = createForm({ props, data, refs, isLoading });
    data.rules = createRules({ props, data, refs, isLoading });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs, isLoading });
    data.conditionForms = createConditionForm({ props, data, refs, isLoading });
    loadForm({ props, data, refs }).then(() => {
        if (props.setAppPageHeader) {
            setAppPageHeader({
                slots: {
                    top: () => createAppPageHeaderTop({ props, data, refs, state, routerPrefix, onClickView, onClickEdit }),
                    default: () => createAppPageHeaderDefault({ props, data, refs })
                }
            });
        }
    });
};

export const initByRole = ({ props, data, refs, key }) => {
    const { menuContext, viewOnly } = props;
    const { useForm, id } = data;
    const { modelRef, initialModel } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const initModel = key ? lodash.get(initialModel, key) : initialModel;
    const prefix = key ? `${key}.` : "";
    const userInfo = store.state.resource.auth.info?.user;
    if (has({ menuContext, key: "forCompany" })) {
        if ([undefined, "Draft"].includes(initModel.refStatus?.key)) {
            if (!viewOnly) {
                if (!modelRef.refCompany) {
                    callUserCompanyByNameTh({}).then(items => {
                        if (items.length > 0) modelRef.refCompany = items[0].refCompany;
                    });
                }
            }
            watch(
                () => {
                    if (["9"].includes(model.refCompanyRequestType?.key) && model.attribute?.refUserTmp) {
                        createRulesCompanyUser({ data, key: "attribute" });
                    }
                },
                { flush: "post" }
            );
        }
        if (!id) {
            model.isOfficerRequest = false;
        }
    } else {
        if (!id) {
            model.isOfficerRequest = true;
        }
    }
    if (has({ menuContext, key: "forCompanyReceive" })) {
        if (["Wait"].includes(initModel.refStatus?.key)) {
            if (!viewOnly) {
                model.receiveDatetime = moment().format("YYYY-MM-DD[T]HH:mm:00Z");
                model.refReceiver = userInfo;
            }
            addRules({ useForm, modelRef, key: `${prefix}receiveDatetime`, rules: [required] });
            addRules({ useForm, modelRef, key: `${prefix}refReceiver`, rules: [required] });
            addRules({
                useForm,
                modelRef,
                key: `${prefix}refStatus`,
                rules: [
                    {
                        validator: (rule, value) => {
                            if (value === undefined || value === null || value?.length === 0 || value?.toString()?.length === 0) {
                                return Promise.reject(i18n.global.t("error.form.required"));
                            }
                            return callCompanyRequestStatusForReceive({}).then(statuses => {
                                if (!statuses.map(d => d.key).includes(value?.key)) {
                                    return Promise.reject(i18n.global.t("error.form.required"));
                                }
                                return Promise.resolve();
                            });
                        },
                        required: true,
                        trigger: "change"
                    }
                ]
            });
        }
    }
    if (have({ menuContext, key: ["forCompanyReview", "forCompanyApprove"] })) {
        if (["1", "2"].includes(model.refCompanyRequestType?.key)) {
            const companyInspections = model.refCompanyTmp?.companyInspections;
            let companyInspection = companyInspections[0];
            if (!companyInspection) {
                companyInspection = createFormCompanyInspection();
                companyInspections.push(companyInspection);
                callInspectionTypeByKey({ key: "1" }).then(inspectionTypes => (companyInspection.refInspectionType = inspectionTypes[0]));
            }
            if (["Wait Review", "Wait Approve"].includes(initModel.refStatus?.key)) {
                if (!viewOnly) {
                    if (!companyInspection.refInspector) companyInspection.refInspector = userInfo;
                }
            }
            createRulesCompanyInspection({ data, key: "refCompanyTmp" });
            watch(
                () => model.refCompanyTmp?.companyInspections?.length,
                () => createRulesCompanyInspection({ data, key: "refCompanyTmp" }),
                { flush: "post" }
            );
        }
    }
    if (["7"].includes(model.refCompanyRequestType?.key)) {
        data.collapsed["CompanyInspection"] = true;
        data.collapsed["SamplingProduct"] = true;
        data.collapsed["CompanyCert"] = true;
    }
    if (["Approve", "Reject"].includes(initModel.refStatus?.key)) {
        if (!viewOnly) {
            Modal.info({ content: i18n.global.t("views.company.companyRequest.editApproveInfo") });
        }
    }
    Object.keys(createRulesCompany({ data, key: `${prefix}refCompanyTmp` }))
        .filter(
            key =>
                key.startsWith(`${prefix}refCompanyTmp.refFactoryAddr`) ||
                key.startsWith(`${prefix}refCompanyTmp.refOfficeAddr`) ||
                key.startsWith(`${prefix}refCompanyTmp.refReportAddr`)
        )
        .forEach(key => {
            addRules({
                useForm,
                modelRef,
                key,
                rules: [requiredWhen({ when: () => ["8"].includes(model.refCompanyRequestType?.key) })],
                isSet: false
            });
        });
    createRulesCompanyAttachment({ data, key: "refCompanyTmp" });
    createRulesCompanyProduct({ data, key: "refCompanyTmp" });
    createRulesCompanyCountry({ data, key: "refCompanyTmp" });
    watch(
        () => model.refCompanyTmp?.companyAttachments?.length,
        () => createRulesCompanyAttachment({ data, key: "refCompanyTmp" }),
        { flush: "post" }
    );
    watch(
        () => model.refCompanyTmp?.companyProducts?.length,
        () => createRulesCompanyProduct({ data, key: "refCompanyTmp" }),
        { flush: "post" }
    );
    watch(
        () => model.refCompanyTmp?.companyCountries?.length,
        () => createRulesCompanyCountry({ data, key: "refCompanyTmp" }),
        { flush: "post" }
    );
    watch(
        () => refs?.companyProductList,
        () => {
            if (["4"].includes(model.refCompanyRequestType?.key)) {
                if (![undefined, "Draft"].includes(initModel.refStatus?.key)) {
                    const sort = refs?.companyProductList?.data?.page?.sort || [];
                    sort.splice(0, sort.length, { name: "isCheckedReject", type: "DESC" });
                }
            }
        },
        { flush: "post" }
    );
    watch(
        () => refs?.companyCountryList,
        () => {
            if (["6"].includes(model.refCompanyRequestType?.key)) {
                if (![undefined, "Draft"].includes(initModel.refStatus?.key)) {
                    const sort = refs?.companyCountryList?.data?.page?.sort || [];
                    sort.splice(0, sort.length, { name: "isCheckedReject", type: "DESC" });
                }
            }
        },
        { flush: "post" }
    );
};

export const createAppPageHeaderDefault = ({ props, data, refs }) => {
    const col1 = [];
    const col2 = [];
    const { menuContext, viewOnly } = props;
    const { useForm } = data;
    const { modelRef, initialModel } = useForm;
    const { id, isActive } = modelRef;
    const canEdit = state.conditionAction.canEdit({ props, record: initialModel });
    const canSendWait = state.conditionAction.canSendWait({ props, record: initialModel });
    const canSendWaitApprove = state.conditionAction.canSendWaitApprove({ props, record: initialModel });
    const canApprove = state.conditionAction.canApprove({ props, record: initialModel });
    const canCancel = state.conditionAction.canCancel({ props, record: initialModel });
    const canReportChangeAddress = state.conditionAction.canReportChangeAddress({ props, record: initialModel });
    if (id && has({ menuContext, key: "canCreate" })) {
        col1.push(createButtonCreate({ onClick: () => onClickCreate({ routerPrefix }), classStyle: "m-1" }));
    }
    if (!viewOnly && id && has({ menuContext, key: "canView" })) {
        col1.push(createButtonView({ onClick: () => onClickView({ record: { id }, routerPrefix }), classStyle: "m-1" }));
    }
    if (viewOnly && id && isActive && has({ menuContext, key: "canEdit" }) && canEdit) {
        col1.push(createButtonEdit({ onClick: () => onClickEdit({ record: { id }, routerPrefix }), classStyle: "m-1" }));
    }
    if (!viewOnly && (!id || (id && isActive && canEdit)) && modelRef.refCompanyTmp) {
        let options = null;
        if (has({ menuContext, key: "forCompanyReceive" })) {
            if (["Wait"].includes(initialModel.refStatus?.key) && modelRef.refStatus?.key !== initialModel.refStatus?.key) {
                options = {
                    text: `${viewOnly ? "" : `${i18n.global.t("button.save")} & `}${modelRef.refStatus?.attribute?.actionText}`,
                    classStyle: `m-1 ${modelRef.refStatus?.attribute?.btnClass}`,
                    confirm: { okButtonProps: { class: modelRef.refStatus?.attribute?.btnClass } }
                };
            }
        }
        col1.push(
            createButtonSave({
                onClick: () => {
                    data.sendApprove = false;
                    data.sendConfirm = false;
                    onClickSave({ props, data, refs });
                },
                classStyle: "m-1",
                options
            })
        );
    }
    if (id && isActive && canSendWait) {
        const statusWait = data.statuses.find(status => status.key === "Wait");
        col1.push(
            createButton({
                text: `${viewOnly ? "" : `${i18n.global.t("button.save")} & `}${statusWait?.attribute?.actionText}`,
                classStyle: `m-1 ${statusWait?.attribute?.btnClass}`,
                onClick: () => {
                    Promise.resolve()
                        .then(() => {
                            modelRef.receiveDatetime = null;
                            modelRef.refReceiver = null;
                            modelRef.remark = null;
                        })
                        .then(() => {
                            data.sendApprove = false;
                            data.sendConfirm = false;
                            onClickSave({ props, data, refs, refStatus: statusWait });
                        });
                },
                icon: viewOnly ? null : <CIcon file="save.svg"></CIcon>,
                confirm: { okButtonProps: { class: statusWait.attribute?.btnClass } }
            })
        );
    }
    if (id && isActive && canSendWaitApprove) {
        const statusWaitApprove = data.statuses.find(status => status.key === "Wait Approve");
        col1.push(
            createButton({
                text: `${viewOnly ? "" : `${i18n.global.t("button.save")} & `}${statusWaitApprove?.attribute?.actionText}`,
                classStyle: `m-1 ${statusWaitApprove?.attribute?.btnClass}`,
                onClick: () => {
                    data.sendApprove = true;
                    data.sendConfirm = false;
                    onClickSave({ props, data, refs, refStatus: statusWaitApprove });
                },
                icon: viewOnly ? null : <CIcon file="save.svg"></CIcon>,
                confirm: { okButtonProps: { class: statusWaitApprove.attribute?.btnClass } }
            })
        );
    }
    if (id && isActive && canApprove) {
        const statusApprove = data.statuses.find(status => status.key === "Approve");
        const statusReject = data.statuses.find(status => status.key === "Reject");
        const textApprove = `${viewOnly ? "" : `${i18n.global.t("button.save")} & `}${statusApprove?.attribute?.actionText}`;
        const textReject = `${viewOnly ? "" : `${i18n.global.t("button.save")} & `}${statusReject?.attribute?.actionText}`;
        col1.push(
            createButton({
                text: textApprove,
                classStyle: `m-1 ${statusApprove?.attribute?.btnClass}`,
                onClick: () => {
                    if (["7"].includes(modelRef.refCompanyRequestType?.key)) {
                        openModalFormRemark({
                            props: { form: { remark: modelRef.refCompanyTmp.privilegeRemark } },
                            title: i18n.global.t("components.table.operatorAndPagination.youAreWant", { text: textApprove }),
                            onClick: record => {
                                Promise.resolve()
                                    .then(() => {
                                        modelRef.refCompanyTmp.privilegeRemark = record.remark;
                                    })
                                    .then(() => {
                                        data.sendApprove = false;
                                        data.sendConfirm = true;
                                        onClickSave({ props, data, refs, refStatus: statusApprove });
                                    });
                            }
                        });
                    } else {
                        data.sendApprove = false;
                        data.sendConfirm = true;
                        onClickSave({ props, data, refs, refStatus: statusApprove });
                    }
                },
                icon: viewOnly ? null : <CIcon file="save.svg"></CIcon>,
                confirm: {
                    okButtonProps: { class: statusApprove.attribute?.btnClass },
                    canHandle: () => !["7"].includes(modelRef.refCompanyRequestType?.key)
                }
            })
        );
        col1.push(
            createButton({
                text: textReject,
                classStyle: `m-1 ${statusReject?.attribute?.btnClass}`,
                onClick: () => {
                    if (["7"].includes(modelRef.refCompanyRequestType?.key)) {
                        openModalFormRemark({
                            title: i18n.global.t("components.table.operatorAndPagination.youAreWant", { text: textReject }),
                            onClick: record => {
                                Promise.resolve()
                                    .then(() => {
                                        modelRef.refCompanyTmp.privilegeRemark = record.remark;
                                    })
                                    .then(() => {
                                        data.sendApprove = false;
                                        data.sendConfirm = false;
                                        onClickSave({ props, data, refs, refStatus: statusReject });
                                    });
                            }
                        });
                    } else {
                        data.sendApprove = false;
                        data.sendConfirm = false;
                        onClickSave({ props, data, refs, refStatus: statusReject });
                    }
                },
                icon: viewOnly ? null : <CIcon file="save.svg"></CIcon>,
                confirm: {
                    okButtonProps: { class: statusReject.attribute?.btnClass },
                    canHandle: () => !["7"].includes(modelRef.refCompanyRequestType?.key)
                }
            })
        );
    }
    if (id && isActive && canReportChangeAddress) {
        col1.push(
            createButton({
                text: i18n.global.t("button.exampleDoc"),
                classStyle: "m-1 btn-primary",
                onClick: () => {
                    onClickReport({ callReport: () => callReportChangeAddress({ data: { id } }), fileName: i18n.global.t("button.exampleDoc") });
                },
                icon: <CIcon file="pdf.svg"></CIcon>
            })
        );
    }
    if (viewOnly && id && isActive && has({ menuContext, key: "canEdit" }) && canEdit) {
        col2.push(
            createButtonCopy({
                onClick: () => {
                    const form = copyForm({ form: data.useForm.modelRef });
                    form.requestNo = null;
                    form.requestDatetime = null;
                    form.refStatus = null;
                    form.receiveDatetime = null;
                    form.refReceiver = null;
                    form.approveDatetime = null;
                    form.refApprover = null;
                    form.refCompanyTmp.id = null;
                    form.refCompanyTmp.version = null;
                    form.refCompanyTmp.refFactoryAddrTh.id = null;
                    form.refCompanyTmp.refFactoryAddrTh.version = null;
                    form.refCompanyTmp.refFactoryAddrEn.id = null;
                    form.refCompanyTmp.refFactoryAddrEn.version = null;
                    form.refCompanyTmp.refOfficeAddrTh.id = null;
                    form.refCompanyTmp.refOfficeAddrTh.version = null;
                    form.refCompanyTmp.refOfficeAddrEn.id = null;
                    form.refCompanyTmp.refOfficeAddrEn.version = null;
                    router.push({
                        name: `${routerPrefix}-create`,
                        params: { props: JSON.stringify({ form }) }
                    });
                },
                classStyle: "m-1"
            })
        );
    }
    if (id && isActive && canCancel) {
        const statusCancel = data.statuses?.find(status => status?.key === "Cancel");
        const userInfo = store.state.resource.auth.info?.user;
        col2.push(
            createButtonCancel({
                options: {
                    text: statusCancel?.attribute?.actionText
                },
                classStyle: `m-1 ${statusCancel?.attribute?.btnClass}`,
                onClick: record => {
                    Promise.resolve()
                        .then(() => {
                            modelRef.refCanceler = userInfo;
                            modelRef.cancelRemark = record?.remark;
                        })
                        .then(() => {
                            onClickSave({ props, data, refs, refStatus: statusCancel });
                        });
                }
            })
        );
    }
    if (viewOnly && id && !isActive && has({ menuContext, key: "canActive" })) {
        col2.push(
            createButtonActive({
                onClick: () =>
                    onClickActive({
                        record: { id },
                        callActive,
                        setIsLoading: setIsLoadingApp,
                        onClickEdit: () => onClickEdit({ record: { id }, routerPrefix })
                    }),
                classStyle: "m-1"
            })
        );
    }
    if (!viewOnly && id && isActive && has({ menuContext, key: "canArchive" })) {
        col2.push(
            createButtonArchive({
                onClick: () =>
                    onClickArchive({
                        record: { id },
                        callArchive,
                        setIsLoading: setIsLoadingApp,
                        onClickView: () => onClickView({ record: { id }, routerPrefix })
                    }),
                classStyle: "m-1"
            })
        );
    }
    if (!viewOnly && id && isActive && has({ menuContext, key: "canDelete" }) && ["Draft"].includes(initialModel?.refStatus?.key)) {
        col2.push(
            createButtonDelete({
                onClick: () => onClickDelete({ record: { id }, callDelete, setIsLoading: setIsLoadingApp, state, routerPrefix }),
                classStyle: "m-1"
            })
        );
    }
    return (
        <Row type="flex">
            <Col>{col1}</Col>
            <Col class="ml-auto">{col2}</Col>
        </Row>
    );
};

export const openModalList = ({ bind, onIframeMounted }) => {
    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleIFrame), bind),
        render: () => (
            <CIFrame
                src={`${process.env.VUE_APP_PUBLIC_PATH}/app/company/company-requests?isLayout=false&canSelect=true&cacheQuery=true`}
                onIframeMounted={({ refs }) => onIframeMounted({ options, refs })}
            ></CIFrame>
        )
    });
    return options;
};

export const state = reactive({
    columns: [],
    page: createPage({
        options: {
            select: ["**", "refCompanyTmp.refDepartment.*", "refCreateBy.fullName"],
            sort: [{ name: "requestDatetime", type: "DESC" }]
        }
    }),
    tableOptions: { search: { activeKey: "Search" } },
    conditionAction: createConditionAction()
});
